import script from "./NotificationComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationComponent.vue?vue&type=script&setup=true&lang=ts"

import "./NotificationComponent.vue?vue&type=style&index=0&id=755f218a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-755f218a"]])

export default __exports__